import React from 'react';

import {
  deletePageContentItem,
  saveSnapshot
} from '@src/actions/wysiwyg/editor';

import ButtonList from '@src/components/wysiwyg_editor/page_content_items/control_panels/ButtonList';
import Delete from '@src/components/wysiwyg_editor/page_content_items/control_panels/Delete';
import { useDispatch } from 'react-redux';

type TProps = {
  itemId: string;
};

function PreContentPanel(props: TProps): React.ReactElement {
  const dispatch = useDispatch();

  return (
    <ButtonList>
      <Delete
        onClick={() => {
          dispatch(saveSnapshot());
          dispatch(deletePageContentItem(props.itemId));
        }}
      />
    </ButtonList>
  );
}

export default PreContentPanel;
